import api from '../../../../../api/client';
import { GROUP_REQUEST } from '../../../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../../../api/handlers';

export async function getGroupRequestList(params = {}) {
  try {
    const response = await api.get(GROUP_REQUEST.LIST, { params });
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getGroupRequestDetail(ymsGroupId) {
  try {
    const response = await api.get(GROUP_REQUEST.DETAIL(ymsGroupId));
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function approveGroupRequest(publicId, formData) {
  try {
    const response = await api.post(GROUP_REQUEST.APPROVE(publicId), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}